import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { OpenOrganisations } from './OpenOrganisations'
import { NewOrganisation } from './NewOrganisation'

export function OrganisationsApp() {
  return (
    <Router>
      <Switch>
        <Route exact path="/organisations/new">
          <NewOrganisation />
        </Route>
        <Route exact path={['/organisations', '/organisations/', '/']}>
          <OpenOrganisations />
        </Route>
      </Switch>
    </Router>
  )
}
